"use client";
import { checkboxAnatomy } from "./checkbox.anatomy.js";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { CheckboxGroupContextProvider } from "./use-checkbox-group-context.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-group-provider.tsx
var splitProviderProps = createSplitProps();
var CheckboxGroupProvider = forwardRef((props, ref) => {
	const [localProps, restProps] = splitProviderProps(props, ["value"]);
	return /* @__PURE__ */ jsx(CheckboxGroupContextProvider, {
		value: localProps.value,
		children: /* @__PURE__ */ jsx(ark.div, {
			ref,
			role: "group",
			...restProps,
			...checkboxAnatomy.build().group.attrs
		})
	});
});
CheckboxGroupProvider.displayName = "CheckboxGroupProvider";
//#endregion
export { CheckboxGroupProvider };
